// Frozen copy of main's code for the document_generation_v4_enabled / agency_brand_design_enabled flag-off path; delete with the flag.
import { Node } from '@tiptap/core';

/**
 * Without a node for it the schema drops a <section> wrapper on load and the next save writes
 * the document back without it. Generated documents declare their pages and full-bleed covers
 * as <section class="cara-page">, so losing the wrapper loses the pagination.
 */
export const SectionNode = Node.create({
  name: 'section',

  group: 'block',
  content: 'block*',

  parseHTML() {
    return [{ tag: 'section' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['section', HTMLAttributes, 0];
  }
});
